import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "289",
  "slug": "spot-turkey-from-satellite-imagery",
  "title": "How to Recognise Turkey in Satellite Images",
  "excerpt": "Much of Turkey occupies the Anatolian Peninsula.",
  "date": "2026-05-05",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/turkey.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Much of Turkey occupies the Anatolian Peninsula. Mountain belts border parts of the Black Sea and Mediterranean coasts, with interior basins between them. Lake Van lies in the east, while the Sea of Marmara and the straits are useful western landmarks."
    },
    {
      "type": "heading",
      "text": "Anatolia between the Black Sea and Mediterranean"
    },
    {
      "type": "paragraph",
      "text": "Find the Sea of Marmara and trace its narrow connections to the neighbouring seas. Then compare that coastal setting with the interior plateau."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Greece and Iran share some Mediterranean or dry upland scenery. Red roofs, dry fields, and folded ridges are too widespread to use alone. Check the orientation of a coast and its mountain belt."
    }
  ],
  "imageAlt": "Turkey regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
